import { Grid, Typography, Box, formControlLabelClasses } from "@mui/material";
import CustomBox from "../Common/CustomBox";
import Card from "../Common/Card";
import FAQ from "../Common/FAQ";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import { useState, useEffect } from "react";
import { LoaderComponent } from "../../../../components/Loader/LoaderComponent";
import HeatmapChart from "../HeatMapChart";
import { useDispatch } from "react-redux";
import { use } from "react";

const faqsStatic = [
  {
    content: "Getting There",
    status: "No",
  },
  {
    content: "Navigation",
    status: "Yes",
  },
  {
    content: "Waiting Area",
    status: "Yes",
  },
  {
    content: "Hygiene",
    status: "No",
  },
  {
    content: "Barrier-free Access",
    status: "No",
  },
  {
    content: "Case Display",
    status: "No",
  },
  {
    content: "Amenities",
    status: "No",
  },
  {
    content: "Security",
    status: "No",
  },
  {
    content: "Website",
    status: "No",
  },
];

export const Overview = ({ dataDistrict, selectedDistrict, dropdownState, stateData }) => {
  const { isSm, isXs, isXss, theme, loader } = useCustomLogic();
  const dispatch = useDispatch();
  let isDistrict = selectedDistrict === "Select District";

  const [faqs, setFaqs] = useState(faqsStatic);
  const [totalPercentage, setTotalPercentage] = useState("");
  const [heatMapGraphData, setHeatMapGraphData] = useState([]);

  useEffect(() => {
    // getOverviewStateData();
    // const filterAllFromStateList = stateData.filter((state) => state.state !== "All");
    stateData.districts_name !== undefined
      ? setHeatMapGraphData(stateData?.districts_name)
      : setHeatMapGraphData(stateData);

    if (dataDistrict) {
      let arr = [
        dataDistrict?.getting_there ?? "",
        dataDistrict?.navigation ?? "",
        dataDistrict?.waiting ?? "",
        dataDistrict?.hygiene ?? "",
        dataDistrict?.disability ?? "", // add barrier here
        dataDistrict?.case_info ?? "",
        dataDistrict?.amenities ?? "",
        dataDistrict?.security ?? "",
        dataDistrict?.website ?? "",
      ];
      setFaqs(faqs?.map((item, index) => ({ ...item, status: arr[index] })));

      let percentage = dataDistrict?.total > 0 ? `${dataDistrict?.total}%` : ""; // Ternary operator for conditional string creation
      setTotalPercentage(percentage);
    }
  }, [dropdownState, dataDistrict, stateData?.districts_name]);

  // const getOverviewStateData = () => {
  //   let path = `/building_better_courts/overview_heat_data?state=${dropdownState}`;
  //   dispatch({
  //     type: "GET_BUILDING_BETTER_COURTS_DATA_OVERVIEW",
  //     path: path,
  //     successCallBack: successCallBackState,
  //   });
  // };

  // const successCallBackState = (res) => {
  //   setHeatMapGraphData(res?.data?.overview_heat_data);
  // };

  return (
    <>
      {loader ? (
        <LoaderComponent height="50vh" />
      ) : (
        <Box>
          {isDistrict ? (
            <Box>
              <Typography variant="regular3" color="secondary.main">
                Comparison of each district/state against each reporting parameter
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mt: "10px",
                  textAlign: "left",
                  letterSpacing: "0.2px",
                  wordSpacing: "1px",
                }}
              >
                Each district court complex was assessed on its performance across nine parameters
                represented in the previous pages. Each parameter has been assigned an equal
                weightage to compute the total percentage score and overall performance for every
                district court complex. District court complexes of Chandigarh and Mohali are the
                best performing in Punjab. The district court complex that needs the most
                improvement in court infrastructure is Hoshiarpur. The last column indicates the
                total score of the district court complex based on its overall score, which is also
                represented by the state map.
              </Typography>
              <Box sx={{ mt: "20px" }}>
                <HeatmapChart heatMapGraphData={heatMapGraphData} dropdownState={dropdownState} />
              </Box>
            </Box>
          ) : (
            <>
              <CustomBox
                content="At a glance, how did this court fare?"
                status={totalPercentage}
                style={{
                  fontSize: "24px",
                  padding: "8px 13px",
                  color: theme.palette.common.black,
                  backgroundColor: "#e6ebf4",
                }}
              />

              {faqs &&
                faqs.map((item, index) => (
                  <FAQ
                    key={index}
                    content={item?.content}
                    status={item?.status}
                    isLastItem={index === faqs.length - 1}
                  />
                ))}
            </>
          )}
        </Box>
      )}
    </>
  );
};
